<template>
    <div>
        <!-- Fixed Header -->
        <header class="theme2-header-fixed">
            <div class="theme2-header-container">
                <div class="theme2-header-left">
                    <button class="theme2-menu-btn" @click="openNav">
                        <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
                        </svg>
                    </button>
                    <div class="theme2-logo-container" @click="$router.push({ path: '/kids-device', query:{ profileId: this.profileId }})">
                        <div class="theme2-logo-icon">W</div>
                        <span class="theme2-logo-text">Wingio</span>
                    </div>
                </div>
                <div class="theme2-header-right">
                    <!-- Online/Offline Status -->
                    <div class="theme2-online-status">
                        <span class="theme2-status-dot" :class="isOnline ? 'online' : 'offline'"></span>
                        <span>{{ isOnline ? 'Online' : 'Offline' }}</span>
                    </div>
                    
                    <button class="theme2-icon-btn" @click="getNotifications">
                        <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
                        </svg>
                        <span v-if="unReadNotificationTotal > 0" class="theme2-notification-dot"></span>
                    </button>
                    <button class="theme2-icon-btn" @click="$router.push({ path: '/parent-profile', query:{ profileId: this.profileId, serialNumber: this.serialNumber }})">
                        <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                        </svg>
                    </button>
                </div>
            </div>
        </header>

        <!-- Sidebar Overlay -->
        <div class="theme2-sidebar-overlay" :class="{'theme2-active': sidebarOpen}" @click="closeNav"></div>

        <!-- Sidebar -->
        <div class="theme2-sidebar" :class="{'theme2-active': sidebarOpen}">
            <div class="theme2-sidebar-header">
                <div class="theme2-logo-container">
                    <div class="theme2-logo-icon">W</div>
                    <span class="theme2-logo-text">Wingio</span>
                </div>
                <button class="theme2-menu-btn" @click="closeNav">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                    </svg>
                </button>
            </div>

            <nav class="theme2-sidebar-nav">
                <button class="theme2-nav-item" :class="{'theme2-active': routerName == 'Kids Devices'}" @click="navigateTo('/kids-device')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
                    </svg>
                    Dashboard
                </button>
                <button class="theme2-nav-item" :class="{'theme2-active': routerName == 'Applications List' || routerName == 'Application'}" @click="navigateTo('/play-store')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/>
                    </svg>
                    Apps
                </button>
                <button class="theme2-nav-item" :class="{'theme2-active': routerName == 'requests'}" @click="navigateTo('/requests')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
                    </svg>
                    Requests
                    <span v-if="requestCount > 0" class="theme2-nav-item-badge">{{ requestCount }}</span>
                </button>
                <button class="theme2-nav-item" :class="{'theme2-active': routerName == 'global-settings'}" @click="navigateTo('/global-settings')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                    </svg>
                    Settings
                </button>
                <button class="theme2-nav-item" :class="{'theme2-active': routerName == 'reports'}" @click="navigateTo('/reports')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                    </svg>
                    Reports
                </button>
                <button class="theme2-nav-item" :class="{'theme2-active': routerName == 'device-info'}" @click="navigateTo('/device-info')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"/>
                    </svg>
                    Device Info
                </button>
                <button class="theme2-nav-item" :class="{'theme2-active': routerName == 'browser-logs'}" @click="navigateTo('/browser-logs')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9"/>
                    </svg>
                    Browser Logs
                </button>
                <button class="theme2-nav-item" :class="{'theme2-active': routerName == 'payment-history'}" @click="navigateTo('/payment-history')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/>
                    </svg>
                    Payment History
                </button>
                <button class="theme2-nav-item" :class="{'theme2-active': routerName == 'payment-methods'}" @click="navigateTo('/payment-methods')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"/>
                    </svg>
                    Payment Methods
                </button>
                <button class="theme2-nav-item" :class="{'theme2-active': routerName == 'change-password'}" @click="navigateTo('/change-password')">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"/>
                    </svg>
                    Change Password
                </button>
            </nav>

            <div class="theme2-sidebar-footer">
                <button class="theme2-logout-btn" @click="logout">
                    <svg class="theme2-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
                    </svg>
                    Logout
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import KidsService from "../../services/KidsService";
import UserService from "../../services/UserService";

export default {
  name: 'KidHeader2',
  props: {
    serialNumber: String,
    profileId: String,
    isOnline: {
        type: Boolean,
        default: false
    }
  },
  data() {
    return {
        routerName: this.$route.name,
        sidebarOpen: false,
        unReadNotificationTotal: 0,
        requestCount: 0
    }
  },
  methods: {
    openNav() {
        this.sidebarOpen = true;
    },
    closeNav() {
        this.sidebarOpen = false;
    },
    logout() {
        this.sidebarOpen = false;
        let data = {
            serialNumber: this.serialNumber,
            profileId: this.profileId
        }     
        UserService.logout(data)
        .then((response) => {
            localStorage.setItem('token', "");
            localStorage.removeItem('token');
            this.$toast.success(response.data.respones_msg);
            
            if (localStorage.getItem('hideGoogleLogin') == "true") {
                document.location = "/login?hideGBtn=true";
            } else {
                this.$router.push('login');
            }
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async getNotifications() {
        this.$router.push({ path: '/notifications', query:{ profileId: this.profileId, serialNumber: this.serialNumber }});
    },
    async unReadNotificationCount() {
        let data = {
            serialNumber: this.serialNumber,
            profileId: this.profileId
        }
        await KidsService.unReadNotificationCount(data)
        .then((response) => {
            this.unReadNotificationTotal = response.data.data
            this.requestCount = response.data.appRequestCount
        }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
            if (e.response.data.is_logout == true) {
                this.$router.push({ path: '/login'})
            }
        });
    },
    navigateTo(path) {
        this.sidebarOpen = false;
        this.$router.push({ 
            path: path, 
            query: { 
                profileId: this.profileId, 
                serialNumber: this.serialNumber 
            } 
        });
    }
  },
  watch: {
    serialNumber() {
        this.unReadNotificationCount();
    }
  },
  beforeMount() {
    this.unReadNotificationCount();
  },
}
</script>

<style scoped>
@import '../../assets/theme2.css';
</style>